import { PropsWithChildren, RefObject } from 'react';
import ClickableDiv from '../clickableDiv/ClickableDiv';
import { Card, CardActions, CardBody, CardFooter } from '@progress/kendo-react-layout';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';

interface FlyoutProps {
  onOverlayClick?: () => void;
  rootClassName?: string;
  ref?: RefObject<HTMLDivElement>;
}

interface FlyoutCloseButtonProps {
  onClose?: () => void;
}

export function FlyoutBase({
  children,
  onOverlayClick,
  rootClassName,
  ref,
}: PropsWithChildren<FlyoutProps>) {
  return (
    <div ref={ref} className="flyout-root">
      <ClickableDiv
        className="flyout-overlay"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          const target = e.target as HTMLElement;
          const isOverlay = target.classList.contains('flyout-overlay');
          if (isOverlay && onOverlayClick) {
            onOverlayClick();
          }
          return;
        }}
      >
        <div className="flyout-panel">
          <Card className={rootClassName}>{children}</Card>
        </div>
      </ClickableDiv>
    </div>
  );
}

export function FlyoutCloseButton({ onClose }: FlyoutCloseButtonProps) {
  return (
    <ClickableDiv className="flyout-panel-close" onClick={() => (onClose ? onClose() : null)}>
      <KwelloSvgIcon icon={KWELLO_ICON.X_ICON} />
    </ClickableDiv>
  );
}

export function FlyoutBody({ children }: PropsWithChildren) {
  return <CardBody className="flyout-body">{children}</CardBody>;
}

export function FlyoutFooter({ children }: PropsWithChildren) {
  return (
    <CardFooter className="flyout-footer">
      <CardActions layout="center">{children}</CardActions>
    </CardFooter>
  );
}
